import React from "react";

interface EmptyStateProps {
  title: string;
  subtitle: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, subtitle }) => {
  return (
    <main className="w-full h-full">
      <div className="flex items-center justify-center border rounded-lg shadow-sm">
        <div className="text-center my-6 mx-2">
          <h1 className="text-xl font-semibold mb-4">{title}</h1>
          <p className="text-base">{subtitle}</p>
        </div>
      </div>
    </main>
  );
};

export default EmptyState;
